module.exports = __webpack_public_path__ + "media/images/btn_confirm_stallion_ship-fdad280f4079ffeb628e50dbcc2f046c.gif";